import React from "react";
import { Card, CardBody, Col, Container, Label, Row } from "reactstrap";
//i18n
import Helmet from "react-helmet";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

// import images
import lock from "../../../assets/images/lock.svg";
import logo from "../../../assets/images/logo_new.svg";

import CustomButton from "../../../components/customButton/customButton";
import HookForm from "../../../components/hookForm/hookForm";
import TextField from "../../../components/textField/textField";

/**
 * A functional component that renders a forgot password form.
 * @param {Object} props - The component props.
 * @param {Function} props.t - The translation function.
 * @param {boolean} props.busy - Indicates if the form is currently submitting.
 * @param {Function} props.onFormSubmit - The function to handle form submission.
 * @param {Object} props.forgotPassForm - The form configuration object.
 * @returns The JSX elements for the forgot password form.
 */
const ForgotPasswordComponent = (props) => {
  /**
   * Destructures the `t` function from the `useTranslation` hook and the `busy`, `onFormSubmit`,
   * and `forgotPassForm` properties from the `props` object.
   * @param {{object}} props - The props object containing the necessary properties.
   * @returns None
   */
  const { t } = useTranslation();
  const { busy, onFormSubmit, forgotPassForm } = props;
  const currentYear = new Date().getFullYear();
  return (
    <React.Fragment>
      <Helmet>
        <title>Forgot Password | RizzTix </title>
      </Helmet>
      <div className="authPages">
        <Container>
          <Row className="justify-content-center ">
            <div className="logoDiv">
              <img src={logo} alt="logo" />
            </div>
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden forgotStyle">
                <div className="bg-primary topContainRow">
                  <Col className="col-7">
                    <h5 className="text-primary">{t("FORGOT_PASSWORD")}</h5>
                    <p className="text-primary">
                      {t("NO_WORRIES_WE_WILL_SEND_YOU_RESET_INSTRUCTIONS")}
                    </p>
                  </Col>
                  <Col className="col-5 d-flex justify-content-end">
                    <img src={lock} alt="" className="img-fluid" />
                  </Col>
                </div>
                <CardBody className="Card_Body">
                  <div className="p-3">
                    <p className="forgotTxtStyle">
                      {t(
                        "ENTER_THE_EMAIL_ADDRESS_ASSOCIATE_TO_YOUR_ACCOUNT_WE’LL_SEND_AN_EMAIL_WITH_OTP_VERIFICATION_CODE_TO_RESET_YOUR_PASSWORD"
                      )}
                    </p>
                    <HookForm
                      defaultForm={{}}
                      /**
                       * Represents a forgot password form object.
                       * @property {{string}} email - The email field of the form.
                       * @property {{string}} email.name - The name of the email field.
                       * @property {{object}} email.validate - The validation rules for the email field.
                       * @property {{boolean}} email.validate.required - Indicates if the email field is required.
                       * @property {{string}} email.validate.message - The error message to display if the email field is not filled.
                       * @property {{object}} email.validate.pattern - The pattern validation rule for the email field.
                       * @property {{string}} email.validate.pattern.value - The regular expression pattern to match against the email field.
                       * @property {{string}} email.validate.pattern.message -
                       */
                      // init={form => setforgotPassForm()}
                      className="form-horizontal"
                      onSubmit={(e) => onFormSubmit(e)}
                    >
                      {(formMethod) => {
                        return (
                          <>
                            <div className="mb-4">
                              <div className="d-flex">
                                <Label>{t("EMAIL_ADDRESS")}</Label>
                                <Label className="requiredStyle">*</Label>
                              </div>
                              <TextField
                                formMethod={formMethod}
                                rules={forgotPassForm.email.validate}
                                name={forgotPassForm.email.name}
                                errors={formMethod?.formState.errors}
                                autoFocus={true}
                                type="text"
                                placeholder={t("ENTER_EMAIL")}
                                iconRightShow={true}
                                autoCapitalize={"none"}
                              />
                            </div>

                            <div className="mt-4 d-grid">
                              <CustomButton
                                className="btn darkBtn btn-primary btn-block"
                                type="submit"
                                title={t("SUBMIT")}
                                disabled={!formMethod?.formState.isValid}
                                loading={busy}
                              />
                            </div>
                          </>
                        );
                      }}
                    </HookForm>
                  </div>
                  <div className="mt-1 mb-3 backTxtStyle text-center">
                    <p className="mb-0">
                      <i className="mdi mdi-arrow-left me-1" />
                      <Link to="/" className="text-primary">
                        {t("BACK_TO_LOGIN")}
                      </Link>{" "}
                    </p>
                  </div>
                </CardBody>
              </Card>
              <div className="copyRightTextStyle text-center">
                <p>{`@${currentYear} ${t("COPYRIGHTS_BY_SIGN_IN")}`}</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ForgotPasswordComponent;
